export const useStorageService = () => {
	const config = useRuntimeConfig()

	const storageUrl = config.public.storageURL

	const locationHeroIMG = 'AdobeStock_589846487.webp'

	return {
		storageUrl,
		locationHeroIMG,
	}
}
